"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function createCallbackRef(callback) {
    var current = null;
    return {
        get current() {
            return current;
        },
        set current(value) {
            var last = current;
            if (last !== value) {
                current = value;
                callback(value, last);
            }
        }
    };
}
exports.createCallbackRef = createCallbackRef;



//////////////////
// WEBPACK FOOTER
// ./~/use-callback-ref/dist/es5/createRef.js
// module id = 407
// module chunks = 0